// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"List__Wrapper_FukUJ container","Title":"List__Title_26mmS","Cells":"List__Cells_bR34G"};